import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Moment from "react-moment";
import Switch from "react-switch";
import * as specialistActions from "../../../actions/specialistActions";
import * as userActions from "../../../actions/usersActions";
import * as SVGICONS from "../../../images/img/images";
import validator from "../../common/validator.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as constant from "../../../constants/constant";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import $ from "jquery";
import * as dashboardActions from "../../../actions/dashboardActions";
// import { this.props.history } from 'react-router';
import * as usersAction from "../../../actions/admin/user/userActions";
import * as gapiAction from "../../../actions/gapiActions";
import CalendarEmailInput from "../../calendar/CalendarEmailInput";

import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../styles/scss/specialistAccounts.css";

var specialistId = localStorage.getItem("userId");

class MySettings extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      // appointmentList: [],
      token: "",
      specialistId: "",
      selectedAddress: "",
      displayDiv: "none",
      userListData: [],
      selectAddressId: "",
      clinicNameCheck: true,
      sortOrder: 1,
      addressCheck: true,
      specialistnameCheck: true,
      degreeCheck: true,
      mobileCheck: true,
      landlineCheck: true,
      emailCheck: true,
      registrationCheck: true,
      signatureCheck: true,
      logoCheck: true,
      signatureimg: "",
      imagePreviewUrl: "",
      logoImage: "",
      signatureImage: "",
      //change password
      patternOne: false,
      patternTwo: false,
      patternThree: false,
      patternFour: false,
      popoverShow: false,
      currentPassword: { value: "", isValid: true, message: "" },
      password: { value: "", isValid: true, message: "" },
      cpassword: { value: "", isValid: true, message: "" },
      striperes: {},
      address: [],
      tabCLicked: 1,
      logoutButton: false,
      image: { value: "", isValid: true, message: "" },

      gender: { value: "Male", isValid: true, message: "" },
      userName: { value: "", isValid: true, message: "" },
      phoneNo: { value: "", isValid: true, message: "" },
      email: { value: "", isValid: true, message: "" },
      items: [
        {
          value: "specialistAssisstant",
          name: "Specialist Assisstant",
          isChecked: false,
        },
      ],
      userType: { value: "", isValid: true, message: "" },
      phoneNoCountryCode: {
        value: localStorage.getItem("calling_code")
          ? localStorage.getItem("calling_code")
          : "",
        isValid: true,
        message: "",
      },
      activePage: 1,
      count: 10,
      usertype: "",
      useriCloudSyncOption: false,
      userOutlookSyncOption: false,
      userGoogleSyncOption: false,
      showModal: false,
      showModal2: false,
      startDate: null,
    };
    this.changePrescriptionData = this.changePrescriptionData.bind(this);
    this.prescriptionHandler = this.prescriptionHandler.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.onPasswordSettingChange = this.onPasswordSettingChange.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.resetValidationStates = this.resetValidationStates.bind(this);
    this.deleteProfile = this.deleteProfile.bind(this);
    this.stripeConnect = this.stripeConnect.bind(this);
    this.fetchPaymentDetails = this.fetchPaymentDetails.bind(this);
    this.fetchClinicDetails = this.fetchClinicDetails.bind(this);
    this.onLogoutclick = this.onLogoutclick.bind(this);
    this.toggle = this.toggle.bind(this);
    this._logout = this._logout.bind(this);
    this.addEditUser = this.addEditUser.bind(this);
    this.onChange = this.onChange.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.goToEditUserPage = this.goToEditUserPage.bind(this);
    this.deleteUser = this.deleteUser.bind(this);

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }
  onChange(event) {
    var state = this.state;
    state[event.target.name].value = event.target.value;

    if (event.target.name == "gender") {
      if (event.target.value == "Male") {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png";
      } else {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";
      }
    }
    //validation code
    if (event.target.name == "userName") {
      if (event.target.value.length > 0) {
        if (!validator.isValidName(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Please enter a valid name";
        } else {
          state[event.target.name].isValid = true;
          state.userName.message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Name is Required";
      }
    } else if (event.target.name == "email") {
      if (event.target.value.length > 0) {
        if (!validator.isEmail(state.email.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Not a valid email address";
          this.setState(state);
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
        }
      } else {
        state.email.isValid = false;
        state.email.message = "Email address is required";
        this.setState(state);
      }
    } else if (event.target.name == "phoneNo") {
      if (event.target.value.length == 0) {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Phone number is required";
      } else if (event.target.value.length > 10) {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Max allowed length is 10";
      } else if (!validator.isOnlyNumber(event.target.value)) {
        state[event.target.name].isValid = false;
        state[event.target.name].message =
          "Only numbers are allowed in phone number";
      } else if (state.phoneNo.value.length < 10) {
        state.phoneNo.isValid = false;
        state.phoneNo.message = "Min allowed length is 10";
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
      }
    }

    this.setState(state);
  }

  _logout(event) {
    let userId = localStorage.getItem("userId");
    this.props.actions.logout({ userId: userId });
    event.preventDefault();
    localStorage.clear();
    this.props.history.push("/");
  }
  toggle() {
    var windowWidth = $(window).width();
    if (windowWidth < 768) {
      $("body").toggleClass("sidebar-open");
    } else {
      $("body").toggleClass("sidebar-collapse");
    }
  }
  onLogoutclick(data) {
    if (this.state.logoutButton == false) {
      this.setState({
        logoutButton: true,
      });
    } else {
      this.setState({
        logoutButton: false,
      });
    }
  }
  componentWillMount() {
    let userToken = localStorage.getItem("token");
    var specialistId = localStorage.getItem("userId");
    let user = JSON.parse(localStorage.getItem("user"));
    let settingsObj = {
      token: userToken,
      doctorId: specialistId,
    };

    let object = {
      specialistId: specialistId,
    };
    this.props.actions.getSpecialistAllAvailabilityAddresses(settingsObj);

    this.props.actions.getSpecialistsAssistant(object);
    if (user.assistId) {
      let assistId = user.assistId;
      this.props.usersAction.getUserById(assistId);
    }
    this.props.gapiAction.getUsersGoogleSyncStatus({ userId: specialistId });
    this.props.gapiAction.getUsersOutlookSyncStatus({ userId: specialistId });
    this.props.gapiAction.getUsersiCloudSyncStatus({ userId: specialistId });
  }

  fetchPaymentDetails(data) {
    let userToken = localStorage.getItem("token");
    let specialistId = localStorage.getItem("userId");
    let settingsObj = {
      token: userToken,
      doctorId: specialistId,
      // isPrimaryAddress : true
    };
    this.setState({
      tabCLicked: data,
    });
    this.props.actions.getSpecialistStripeDetails(settingsObj, this.props);
  }

  fetchClinicDetails(data) {
    let userToken = localStorage.getItem("token");
    let specialistId = localStorage.getItem("userId");
    let settingsObj = {
      token: userToken,
      doctorId: specialistId,
      // isPrimaryAddress : true
    };
    this.setState({
      tabCLicked: data,
    });
    this.props.actions.getSpecialistAllAvailabilityAddresses(settingsObj);
  }
  //new
  stripeConnect() {
    window.open(
      "https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=ca_F2ekiAD6wmg40yBpYglvO5uWwEyRxyip&scope=read_write"
    );
  }
  // test
  // stripeConnect() {

  // 	window.open("https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=ca_ExIG1un2JnkSDTi76cqNBRvxGfkWpzvh&scope=read_write", "_self");
  // }

  //production
  // stripeConnect() {

  // 	window.open("https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=ca_F2ekiAD6wmg40yBpYglvO5uWwEyRxyip&scope=read_write");
  // }

  togglePrescription(e) {
    if (document.getElementById(e.target.id).checked == true) {
      if (e.target.id == "logo")
        document.getElementById(e.target.id + "defaultdiv").style.display =
          "block";
      if (e.target.id == "signature")
        document.getElementById(e.target.id + "defaultdiv").style.display =
          "block";
      document.getElementById(e.target.id + "div").style.display = "block";
    } else {
      if (e.target.id == "logo")
        document.getElementById(e.target.id + "defaultdiv").style.display =
          "none";
      if (e.target.id == "signature")
        document.getElementById(e.target.id + "defaultdiv").style.display =
          "none";
      document.getElementById(e.target.id + "div").style.display = "none";
    }
  }

  deleteProfile() {
    confirmAlert({
      title: "Confirm",
      message: "Do you wish to Delete your account? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            var obj = {
              userId: localStorage.getItem("userId"),
            };
            this.props.actions.deleteDoctorAccount(obj);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  addEditUser(event) {
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};

    event.preventDefault();
    let state = this.state;
    // let permissionData = state.items.filter(item => item.isChecked == true);
    // if (permissionData.length == 0) {
    // 	state.userType.isValid = false;
    // 	state.userType.message = 'Please select user type';
    // 	this.setState(state);
    // }
    if (state.userName || !state.userName) {
      if (state.userName.value != undefined && state.userName.value != "") {
        if (!validator.isValidName(state.userName.value)) {
          state.userName.isValid = false;
          state.userName.message = "Please enter a valid name";
          this.setState(state);
        } else {
          state.userName.isValid = true;
          state.userName.message = "";
          this.setState(state);
        }
      } else {
        state.userName.isValid = false;
        state.userName.message = "Name is Required";
        this.setState(state);
      }
    } else {
      state.userName.isValid = false;
      state.userName.message = "Name is Required";
      this.setState(state);
    }

    if (state.email || !state.email) {
      if (
        (state.email.value != undefined && state.email.value != "") ||
        document.getElementById("email").value != ""
      ) {
        if (
          !validator.isEmail(state.email.value) &&
          !validator.isEmail(document.getElementById("email").value)
        ) {
          state.email.isValid = false;
          state.email.message = "Not a valid email address";
          this.setState(state);
        } else {
          state.email.isValid = true;
          state.email.message = "";
          this.setState(state);
        }
      } else {
        state.email.isValid = false;
        state.email.message = "Email address is required";
        this.setState(state);
      }
    } else {
      state.email.isValid = false;
      state.email.message = "Email address is required";
      this.setState(state);
    }

    if (state.phoneNo || !state.phoneNo) {
      if (
        (state.phoneNo.value == "" || state.phoneNo.value == undefined) &&
        document.getElementById("phoneNo").value == ""
      ) {
        state.phoneNo.isValid = false;
        state.phoneNo.message = "Phone number is required";
      } else if (
        state.phoneNo.value.length > 10 ||
        document.getElementById("phoneNo").value.length > 10
      ) {
        state.phoneNo.isValid = false;
        state.phoneNo.message = "Max allowed length is 10";
      } else if (
        state.phoneNo.value.length < 10 ||
        document.getElementById("phoneNo").value.length > 10
      ) {
        state.phoneNo.isValid = false;
        state.phoneNo.message = "Min allowed length is 10";
      } else if (
        !validator.isOnlyNumber(state.phoneNo.value) ||
        !validator.isOnlyNumber(document.getElementById("phoneNo").value)
      ) {
        state.phoneNo.isValid = false;
        state.phoneNo.message = "Only numbers are allowed in phone number";
      } else {
        state.phoneNo.isValid = true;
        state.phoneNo.message = "";
      }
    }

    let userId = user.assistId;
    if (
      this.state.userName.value != "" &&
      this.state.phoneNo.value != "" &&
      this.state.email.value != "" &&
      (this.state.phoneNo.message == "" ||
        this.state.phoneNo.message == undefined) &&
      (this.state.email.message == "" ||
        this.state.email.message == undefined) &&
      (this.state.userName.message == "" ||
        this.state.userName.message == undefined) &&
      (this.state.gender.message == "" ||
        this.state.gender.message == undefined) &&
      (this.state.userType.message == "" ||
        this.state.userType.message == undefined)
    ) {
      let user = {
        userName: this.state.userName.value,
        gender: this.state.gender.value,
        phoneNo: this.state.phoneNo.value,
        email: this.state.email.value,
        phoneNoCountryCode: this.state.phoneNoCountryCode.value
          ? this.state.phoneNoCountryCode.value
          : "+91",
        permissionData: this.state.items,
        userId: userId,
      };
      this.props.usersAction.updateUser(user);
    }
  }
  handleFileUpload(event) {
    var flag = true;
    if (
      event.target.name == "signatureImage" ||
      event.target.name == "logoImage"
    ) {
      if (event.target.files.length > 0) {
        if (!validator.ImageValidateFormate(event.target.files[0])) {
          toast.error("Please choose following format jpeg, jpg, png, gif");
          flag = false;
        } else if (!validator.fileValidateSize(event.target.files[0])) {
          toast.error("File size must be less than 10 MB.");
          flag = false;
        }
        // else {
        // 	let reader = new FileReader();
        // 	let file = event.target.files[0];
        // 	reader.onloadend = () => {
        // 		this.setState({
        // 			file: file,
        // 			imagePreviewUrl: reader.result
        // 		});
        // 	}
        // }
      }
    }
    if (
      event.target.name == "signatureImage" ||
      (event.target.name == "logoImage" && flag)
    ) {
      // debugger
      let settingsObj = {};
      let specialistId = localStorage.getItem("userId");
      if (event.target.name == "signatureImage") {
        document.getElementById("signaturedefaultdiv").style.display = "none";
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result,
          });
        };
        reader.readAsDataURL(file);
        settingsObj = {
          doctorId: specialistId,
          availabilityId: this.state.selectAddressId,
          file: file,
          type: "signature",
        };
      } else {
        document.getElementById("logodefaultdiv").style.display = "none";
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.onloadend = () => {
          this.setState({ file: file, previewLogoUrl: reader.result });
        };
        reader.readAsDataURL(file);
        settingsObj = {
          doctorId: specialistId,
          availabilityId: this.state.selectAddressId,
          file: file,
          type: "logo",
        };
      }

      this.setState({ [event.target.name]: event.target.files[0] });
      this.props.actions.addPrescriptionImages(settingsObj);
    } else {
      // document.getElementById(event.target.name+'div').style.display = 'block';
      this.setState({ [event.target.name]: event.target.value });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.history.location.state &&
      this.props.history.location.state.selected == "addUser"
    ) {
      var specialistId = localStorage.getItem("userId");

      let object = {
        specialistId: specialistId,
      };

      this.props.actions.getSpecialistsAssistant(object);
      this.setState({ tabCLicked: 5 }, () => {});
    }
    var state = this.state;
    state.file = "";
    (state.userName = {
      value: nextProps.userData.userName
        ? nextProps.userData.userName
        : state.userName.value,
    }),
      (state.gender = {
        value: nextProps.userData.gender
          ? nextProps.userData.gender
          : state.gender.value,
      }),
      (state.image = {
        value: nextProps.userData.adminProfileImage
          ? nextProps.userData.adminProfileImage
          : state.image.value,
      }),
      // state.bloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.bloodGroupList,
      // state.replicaBloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.replicaBloodGroupList,
      (state.email = {
        value: nextProps.userData.email
          ? nextProps.userData.email
          : state.email.value,
        email: nextProps.userData.email,
      }),
      // state.dateOfBirth = { value: nextProps.userData.dateOfBirth ? moment(nextProps.userData.dateOfBirth) : this.state.dateOfBirth.value },
      // state.bloodGroup = { value: nextProps.userData.bloodGroup ? nextProps.userData.bloodGroup : state.bloodGroup.value },
      (state.items = nextProps.userData.permission
        ? nextProps.userData.permission
        : this.state.items),
      (state.phoneNo = {
        value: nextProps.userData.phoneNo
          ? nextProps.userData.phoneNo.toString()
          : state.phoneNo.value,
      }),
      (state.imageCopy = nextProps.userData.adminProfileImage
        ? nextProps.userData.adminProfileImage
        : state.imageCopy),
      (state.phoneNoCountryCode = {
        value: nextProps.userData.phoneNoCountryCode
          ? nextProps.userData.phoneNoCountryCode
          : state.phoneNoCountryCode.value,
      }),
      this.setState({ state });
    // debugger;
    if (
      nextProps.specialistListAssistant &&
      nextProps.specialistListAssistant.assistants
    ) {
      this.setState({
        specialistAssistant: nextProps.specialistListAssistant,
      });
    }
    if (
      nextProps.striperes &&
      nextProps.striperes.email &&
      nextProps.striperes.email != ""
    ) {
      this.setState({
        striperes: nextProps.striperes,
      });
      this.state.striperes = nextProps.striperes;
    }

    if (nextProps.address) {
      this.setState({
        address: nextProps.address,
        striperes: nextProps.striperes,
      });
    }
    if (localStorage.getItem("isClicked") === "true") {
      localStorage.removeItem("isClicked");
      var user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {};
      // debugger;
      if (user.assistId) {
        this.setState({
          tabCLicked: 2,
        });
      } else {
        this.setState({
          tabCLicked: 1,
        });
      }
    }

    if (nextProps.gapi.urlToRedirect) {
      window.location.href = nextProps.gapi.urlToRedirect;
    }

    if (nextProps.gapi.user_google_sync_option !== null) {
      this.setState({
        userGoogleSyncOption: nextProps.gapi.user_google_sync_option,
      });
    }
    if (nextProps.gapi.user_outlook_sync_option !== null) {
      this.setState({
        userOutlookSyncOption: nextProps.gapi.user_outlook_sync_option,
      });
    }
    if (nextProps.gapi.user_icloud_sync_option !== null) {
      this.setState({
        useriCloudSyncOption: nextProps.gapi.user_icloud_sync_option,
      });
    }
  }
  componentDidMount() {
    this.setState(
      {
        tabCLicked: 1,
      },
      () => {
        if (
          this.props.history.location.state &&
          this.props.history.location.state.selected == "addUser"
        ) {
          this.setState({ tabCLicked: 5 }, () => {});
        }
      }
    );
  }

  changePrescriptionData(e) {
    if (e.target.value != "") {
      e.preventDefault();
      this.setState({
        displayDiv: "block",
        selectedAddress: this.state.address[e.target.value],
        selectAddressId: this.state.address[e.target.value].data._id,
        // clinicNameCheck: this.state.address[e.target.value].data.prescriptions.clinicName,
      });

      for (const field in this.refs) {
        this.refs[field].checked = this.state.address[
          e.target.value
        ].data.prescriptions[field];
        if (document.getElementById(field + "div"))
          document.getElementById(field + "div").style.display = this.state
            .address[e.target.value].data.prescriptions[field]
            ? "block"
            : "none";
        if (document.getElementById(field + "defaultdiv"))
          document.getElementById(field + "defaultdiv").style.display = this
            .state.address[e.target.value].data.prescriptions[field]
            ? "block"
            : "none";
        if (
          this.state.address[e.target.value].data.prescriptions.logoImage !=
          null
        )
          document.getElementById("logodefaultdiv").style.display = "none";
        if (
          this.state.address[e.target.value].data.prescriptions
            .signatureImage != null
        )
          document.getElementById("signaturedefaultdiv").style.display = "none";
      }
    } else {
      this.setState({
        displayDiv: "none",
      });
    }
  }

  prescriptionHandler(e) {
    e.preventDefault();

    const formData = {};
    for (const field in this.refs) {
      formData[field] = this.refs[field].checked;
    }

    let userToken = localStorage.getItem("token");
    let specialistId = localStorage.getItem("userId");

    let settingsObj = {
      doctorId: specialistId,
      formData: formData,
      availabilityId: this.state.selectAddressId,
      type: "data",
    };
    this.props.actions.addPrescriptionData(settingsObj);
  }

  // **************** change function password section *********************

  onPasswordSettingChange(e) {
    var state = this.state;
    state[e.target.name].value = e.target.value;
    this.resetValidationStates();
    if (e.target.name == "password") {
      this.setState({ popoverShow: true });
      if (e.target.value.length > 0) {
        if (
          validator.atLeastOneLetter(state.password.value) ||
          validator.atLeastOneCapitalLetter(state.password.value) ||
          validator.atLeastOneNumber(state.password.value) ||
          validator.atLeastEightCharacters(state.password.value)
        ) {
          if (validator.atLeastOneLetter(state.password.value)) {
            state.patternOne = true;
          } else {
            state.patternOne = false;
          }
          if (validator.atLeastOneCapitalLetter(state.password.value)) {
            state.patternTwo = true;
          } else {
            state.patternTwo = false;
          }
          if (validator.atLeastOneNumber(state.password.value)) {
            state.patternThree = true;
          } else {
            state.patternThree = false;
          }
          if (validator.atLeastEightCharacters(state.password.value)) {
            state.patternFour = true;
          } else {
            state.patternFour = false;
          }
        } else {
          return true;
        }
        if (
          state.patternOne &&
          state.patternTwo &&
          state.patternThree &&
          state.patternFour
        ) {
          state.password.isValid = true;
          state.password.message = "";
          state.popoverShow = false;
        } else {
          state.password.isValid = false;
          state.password.message = "Not a valid password";
          state.popoverShow = true;
        }
      } else {
        state.patternOne = false;
        state.patternTwo = false;
        state.patternThree = false;
        state.patternFour = false;
        state.password.isValid = false;
        state.password.message = "Password is required";
        state.popoverShow = false;
      }
    } else if (e.target.name == "cpassword") {
      if (e.target.value.length > 0) {
        if (state.password.value != state.cpassword.value) {
          state.cpassword.isValid = false;
          state.cpassword.message = "Passwords do not match";
          this.setState(state);
        } else {
          return true;
        }
      } else {
        state.cpassword.isValid = false;
        state.cpassword.message = "Confirm password is required";
        this.setState(state);
      }
    } else if (e.target.name == "currentPassword") {
      if (e.target.value.length > 0) {
        if (!validator.isValid(state.currentPassword.value)) {
          state.currentPassword.isValid = false;
          state.currentPassword.message = "Not a valid currentPassword";
          this.setState(state);
        } else {
          return true;
        }
      } else {
        state.currentPassword.isValid = false;
        state.currentPassword.message = "Current Password is required";
        this.setState(state);
      }
    }
    this.setState(state);
  }

  resetValidationStates() {
    var state = this.state;

    Object.keys(state).map((key) => {
      if (state[key].hasOwnProperty("isValid")) {
        state[key].isValid = true;
        state[key].message = "";
      }
    });
    this.setState(state);
  }
  // resetValidationStates() {
  // 	var state = this.state;

  // 	Object.keys(state).map(key => {
  // 		if (state[key].hasOwnProperty('isValid')) {
  // 			state[key].isValid = true;
  // 			state[key].message = '';
  // 		}
  // 	});
  // 	this.setState(state);
  // }
  // function for set sort icon on table header
  _sortClass(filterName) {
    return (
      "fa fa-fw " +
      (filterName == this.state.sortColumnName
        ? "fa-sort-" + this.state.sortOrder
        : "fa-sort")
    );
  }

  //function for sorting
  sortChanged(sortColumnName, order, e) {
    return;
    e.preventDefault();
    this.state.sortColumnName = sortColumnName;
    this.state.page = 1;
    this.state.sortOrder = order == 1 ? -1 : 1;

    let userToken = localStorage.getItem("token");
    // let patientId = localStorage.getItem('userId');
    const sorting = {};
    sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1;
    this.state.sorting = sorting;
    let appointmentObj = {
      token: userToken,
      page: this.state.activePage,
      count: this.state.count,
      sorting: sorting,
      specialistId: localStorage.getItem("userId"),
    };

    this.props.actions.getSpecialistsAssistant(appointmentObj);
  }

  goToAddUserPage() {
    localStorage.setItem("urlLocation", "/user/userList");
    this.props.history.push("/specialist/add-user");
  }
  goToEditUserPage(index) {
    localStorage.setItem("urlLocation", "/user/userList");
    this.props.history.push(
      "/specialist/edit-user/" +
        this.state.specialistAssistant.assistants[index]._id
    );
  }
  //api calling
  changePassword() {
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    var state = this.state;
    if (state.password || !state.password) {
      this.setState({ popoverShow: true });
      if (state.password.value.length > 0) {
        if (
          validator.atLeastOneLetter(state.password.value) ||
          validator.atLeastOneCapitalLetter(state.password.value) ||
          validator.atLeastOneNumber(state.password.value) ||
          validator.atLeastEightCharacters(state.password.value)
        ) {
          if (validator.atLeastOneLetter(state.password.value)) {
            state.patternOne = true;
          } else {
            state.patternOne = false;
          }
          if (validator.atLeastOneCapitalLetter(state.password.value)) {
            state.patternTwo = true;
          } else {
            state.patternTwo = false;
          }
          if (validator.atLeastOneNumber(state.password.value)) {
            state.patternThree = true;
          } else {
            state.patternThree = false;
          }
          if (validator.atLeastEightCharacters(state.password.value)) {
            state.patternFour = true;
          } else {
            state.patternFour = false;
          }
        } else {
          // return true
          state.password.message = "";
          state.password.isValid = true;
        }
        if (
          state.patternOne &&
          state.patternTwo &&
          state.patternThree &&
          state.patternFour
        ) {
          state.password.isValid = true;
          state.password.message = "";
          state.popoverShow = false;
        } else {
          state.password.isValid = false;
          state.password.message = "Not a valid password";
          state.popoverShow = true;
        }
      } else {
        state.patternOne = false;
        state.patternTwo = false;
        state.patternThree = false;
        state.patternFour = false;
        state.password.isValid = false;
        state.password.message = "Password is required";
        state.popoverShow = false;
      }
    }
    if (state.cpassword || !state.cpassword) {
      if (state.cpassword.value.length > 0) {
        if (state.password.value != state.cpassword.value) {
          state.cpassword.isValid = false;
          state.cpassword.message = "Passwords do not match";
          this.setState(state);
        } else {
          state.cpassword.isValid = true;
          state.cpassword.message = "";
        }
      } else {
        state.cpassword.isValid = false;
        state.cpassword.message = "Confirm password is required";
        this.setState(state);
      }
    }
    if (state.currentPassword || !state.currentPassword) {
      if (state.currentPassword.value.length > 0) {
        if (!validator.isValid(state.currentPassword.value)) {
          state.currentPassword.isValid = false;
          state.currentPassword.message = "Not a valid currentPassword";
          this.setState(state);
        } else {
          state.currentPassword.isValid = true;
          state.currentPassword.message = "";
        }
      } else {
        state.currentPassword.isValid = false;
        state.currentPassword.message = "Current Password is required";
        this.setState(state);
      }
    }

    if (
      this.state.password.value != "" &&
      this.state.cpassword.value != "" &&
      this.state.currentPassword.value != "" &&
      (this.state.password.message == "" ||
        this.state.password.message == undefined) &&
      (this.state.cpassword.message == "" ||
        this.state.cpassword.message == undefined) &&
      (this.state.currentPassword.message == "" ||
        this.state.currentPassword.message == undefined) &&
      this.state.patternOne == true &&
      this.state.patternTwo == true &&
      this.state.patternThree == true &&
      this.state.patternFour == true
    ) {
      if (this.state.password.value == this.state.cpassword.value) {
        let passwordObj = {
          userId: user._id,
          oldPassword: this.state.currentPassword.value,
          newPassword: this.state.password.value,
        };
        this.props.changePassactions.changePassword(passwordObj);
        this.setState({
          currentPassword: { value: "" },
          password: { value: "" },
          cpassword: { value: "" },
          popoverShow: false,
        });
      } else {
        toast.error(message.PASSWORDS_DIFFERENT);
        this.setState({
          currentPassword: { value: "" },
          password: { value: "" },
          cpassword: { value: "" },
          popoverShow: false,
        });
      }
    }
  }

  onChangeTab(data) {
    this.setState({
      tabCLicked: data,
    });
  }
  deleteImage() {
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    var delImage = {
      userId: user.assistId,
      userType: "Admin",
    };
    this.props.usersAction.deleteImageProfile(delImage);
  }
  uploadAdminUserImage(event) {
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    //To change the view immediately after uploading image
    event.preventDefault();
    // this.resetValidationStates();
    if (event.target.name == "image") {
      if (event.target.files.length > 0) {
        if (!validator.ImageValidateFormate(event.target.files[0])) {
          toast.error("Please choose following format jpeg, jpg, png, gif");
        } else if (!validator.fileValidateSize(event.target.files[0])) {
          toast.error("File size must be less than 10 MB.");
        } else {
          let reader = new FileReader();
          let file = event.target.files[0];
          this.setState({
            image: { value: file },
          });
          reader.onloadend = () => {
            this.setState({
              file: file,
              imagePreviewUrl: reader.result,
            });
          };

          reader.readAsDataURL(file);

          this.setState({ [event.target.name]: event.target.files[0] });
          let patientObj = {
            file: event.target.files[0],
            userId: user.assistId,
          };
          this.props.usersAction.uploadAdminUserImage(patientObj);
        }
      }
    }
  }
  onrenderimage() {
    if (
      this.state.image.value == "" ||
      this.state.image.value == "noUserImage.jpg"
    ) {
      if (this.state.gender.value == "Male") {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png";
      } else {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";
      }
    } else {
      this.state.defaultImageURL =
        constant.PRODUCTION_IMAGE_URL +
        constant.UPLOAD_FOLDER +
        "/" +
        "admin" +
        "/" +
        this.state.imageCopy;
    }
  }
  deleteUser(user) {
    confirmAlert({
      title: "Confirm",
      message: "Do you wish to delete this  user " + user.userName + " ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let userObject = {
              page: this.state.activePage,
              count: this.state.count,
              userType: "Assistant",
            };
            let userId = user._id;
            this.props.usersAction.deleteUser(userObject, userId);
          },
        },
        {
          label: "No",
          // onClick: () => { this.props.history.push('specialist/my-settings'); }
        },
      ],
    });
  }
  // uploadSignatureImage(event) {
  // 	//To change the view immediately after uploading image
  // 	event.preventDefault();

  // 	if (event.target.name == "image") {
  // 		if (event.target.files.length > 0) {
  // 			if (!validator.ImageValidateFormate(event.target.files[0])) {
  // 				toast.error('Please choose following format jpeg, jpg, png, gif')
  // 			} else if (!validator.fileValidateSize(event.target.files[0])) {
  // 				toast.error('File size must be less than 10 MB.')

  // 			} else {
  // 				let reader = new FileReader();
  // 				let file = event.target.files[0];

  // 				reader.onloadend = () => {
  // 					this.setState({
  // 						file: file,
  // 						defaultImageURL: reader.result
  // 					});
  // 				}

  // 				reader.readAsDataURL(file);
  // 				this.setState({ [event.target.name]: event.target.files[0] });
  // 				let specialistObj = {
  // 					file: event.target.files[0],
  // 					userId: localStorage.getItem('userId')
  // 				}
  // 				this.props.actions.uploadSignatureImage(specialistObj)

  // 			}
  // 		}

  // 	}
  // }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    this.handleClick();
  }
  handleClick() {
    if (!this.state.logoutButton) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      logoutButton: !prevState.logoutButton,
    }));
  }
  calendarSettings = (data) => {
    this.setState({
      tabCLicked: data,
    });
  };
  syncWithGoogle = (data) => {
    this.setState({ userGoogleSyncOption: !this.state.userGoogleSyncOption });
    let specialistId = localStorage.getItem("userId");
    confirmAlert({
      title: "Confirm",
      message: `Do you really want to ${
        data == true ? "sync" : "unsync"
      } appointments with Google Calendar`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            if (data == true) this.props.gapiAction.getGapiAuth();
            if (data == false) {
              let bodyData = {
                code: "",
                action: "REVOKE",
              };
              this.props.gapiAction.putGapiToken(bodyData, this.props);
            }
            // this.props.gapiAction.getOutlookAuth();
            // this.props.usersAction.deleteUser(userObject, userId);
          },
        },
        {
          label: "No",
          onClick: () => {
            this.props.gapiAction.getUsersGoogleSyncStatus({
              userId: specialistId,
            });
          },
        },
      ],
    });
  };
  syncWithOutlook = (data) => {
    this.setState({ userOutlookSyncOption: !this.state.userOutlookSyncOption });
    confirmAlert({
      title: "Confirm",
      message: `Do you really want to ${
        data == true ? "sync" : "unsync"
      } appointments Outlook Calendar`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            if (data == true) this.props.gapiAction.getOutlookAuth();
            if (data == false) {
              let bodyData = {
                code: "",
                action: "REVOKE",
              };
              this.props.gapiAction.putOutlookToken(bodyData, this.props);
            }
          },
        },
        {
          label: "No",
          onClick: () => {
            this.props.gapiAction.getUsersOutlookSyncStatus({
              userId: specialistId,
            });

            // this.setState({ userOutlookSyncOption: this.state.userOutlookSyncOption }, () => {
            //
            // })
          },
        },
      ],
    });
  };
  syncWithIcloud = (data) => {
    let bodyData = {
      iCloudEmailAddress: "",
      action: "REVOKE",
    };
    confirmAlert({
      title: "Confirm",
      message: `Do you really want to ${
        data == 1 ? "sync" : "unsync"
      } appointments with icalendar`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            if (data == 1) this.setState({ icloudEmailInput: true });
            // this.props.gapiAction.getiCalFile();
            // this.props.gapiAction.getOutlookAuth();
            if (data == 2) {
              this.props.gapiAction.storeUseriCloudEmail(bodyData, this.props);
            }
          },
        },
        {
          label: "No",
          onClick: () => {
            // this.props.history.push('specialist/my-settings');
          },
        },
      ],
    });
  };
  // unSyncWithGoogle = (data) => {
  // 	let bodyData = {
  // 		code: "",
  // 		action: 'REVOKE'
  // 	}
  // 	confirmAlert({
  // 		title: 'Confirm',
  // 		message: `Do you really want to unsync appointments from ${data == 1 ? 'Google' : 'Outlook'} Calendar`,
  // 		buttons: [
  // 			{
  // 				label: 'Yes',
  // 				onClick: () => {
  // 					if (data == 1)
  // 						this.props.gapiAction.putGapiToken(bodyData, this.props);
  // 					// this.props.gapiAction.getGapiAuth();
  // 					if (data == 2)
  // 						this.props.gapiAction.putOutlookToken(bodyData, this.props)
  // 					// this.props.gapiAction.getOutlookAuth();
  // 					// this.props.usersAction.deleteUser(userObject, userId);
  // 					// this.props.usersAction.deleteUser(userObject, userId);
  // 				}
  // 			},
  // 			{
  // 				label: 'No',
  // 				// onClick: () => { this.props.history.push('specialist/my-settings'); }
  // 			}
  // 		]
  // 	})
  // }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
    console.log(111)
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  handleOpenModal2 = () => {
    this.setState({ showModal: false });
    this.setState({ showModal2: true });
  };

  closeModal2 = () => {
    this.setState({ showModal2: false });
  };

  render() {
    var imageName = localStorage.prescriptionImage;
    var countryCodeList = constant.PHONENOCOUNTRYCODE
      ? constant.PHONENOCOUNTRYCODE
      : [];
    var userListData = this.state.userListData;
    var address = this.state.address;
    // this.uploadSignatureImage = this.uploadSignatureImage.bind(this);
    let userData = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    let user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    var isAssistant = user && user.assistId ? true : false;

    var defaultImagePath =
      user.gender == "Male"
        ? constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png"
        : constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";
    var imagesPath =
      constant.PRODUCTION_IMAGE_URL +
      constant.UPLOAD_FOLDER +
      localStorage.getItem("userId") +
      "/" +
      imageName;
    if (user.adminImage == constant.DEFAULT_USER_IMAGE) {
      if (utextser.gender == "Male") {
        imagePath =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png";
      } else {
        imagePath =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";
      }
    } else {
      var imagePath =
        constant.PRODUCTION_IMAGE_URL +
        constant.UPLOAD_FOLDER +
        localStorage.getItem("userId") +
        "/" +
        user.image;
    }
    var rows = [];
    rows.push(
      <select
        className='form-control'
        style={{ border: 0 }}
        name='specialization'
        onChange={this.changePrescriptionData.bind(this)}
      >
        <option value=''>Select Address </option>
        {this.state.address && this.state.address.length > 0
          ? this.state.address.map((option, index) => (
              <option
                value={index}
                key={option.data && option.data._id + Math.random()}
              >
                {option.data ? option.data.clinicName : ""}
              </option>
            ))
          : ""}
      </select>
    );
    // var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    var condition =
      (user.userName != undefined || user.gender != undefined) &&
      user.availabilityCount > 0 &&
      user.isVerified == "2";
    {
      this.onrenderimage();
    }
    var rowsList = [];
    {
      this.state.specialistAssistant
        ? this.state.specialistAssistant.assistants.forEach(
            function (item, index) {
              rowsList.push(
                <tr key={index}>
                  <td>{item.userName}</td>
                  <td>{item.email} </td>
                  <td>
                    {" "}
                    <Moment format='DD-MMM-YYYY'>{item.createdAt}</Moment>{" "}
                  </td>
                  {/* <td> <Moment format="DD-MMM-YYYY">{item.createdAt}</Moment>     </td> */}
                  <td>
                    <Link
                      onClick={this.goToEditUserPage.bind(this, index)}
                      style={{ cursor: "pointer", marginRight: 10 }}
                      className='redLink edit-icon-bottom'
                    >
                      <img
                        src={require("../../../images/edit.png")}
                        alt=''
                        width='14px'
                      />
                    </Link>
                    <Link
                      onClick={this.deleteUser.bind(this, item)}
                      style={{ cursor: "pointer" }}
                      className='redLink'
                    >
                      <i className='fa fa-trash'></i>
                    </Link>
                  </td>
                </tr>
              );
            }.bind(this)
          )
        : null;
    }

    var userType = localStorage.getItem("userType");
    return (
      <div>
        <header className='section-accounts__main main-header'>
          <Link
            to={condition ? "/specialist/my-appointment" : null}
            className='logo'
          >
            <span className='logo-mini'>
              {userType === "specialist" ? (
                <img src={require("../../../images/favicon.ico")} alt='' />
              ) : (
                <img
                  src={require("../../../images/img/logo_er_ms.png")}
                  alt=''
                />
              )}
            </span>
            <span className='logo-lg'>
              {userType === "specialist" ? (
                <img src={require("../../../images/images/logo.svg")} alt='' />
              ) : (
                <img
                  src={require("../../../images/img/logo_er_old.png")}
                  alt=''
                />
              )}
            </span>{" "}
          </Link>
          <nav className='navbar navbar-static-top' role='navigation'>
            <Link
              href='#'
              className='sidebar-toggle'
              data-toggle='push-menu'
              role='button'
              onClick={this.toggle}
            >
              {" "}
              <img
                src={require("../../../images/img/menu_list.svg")}
                alt=''
              />{" "}
              <span className='sr-only'>Toggle navigation</span>{" "}
            </Link>
            <div className='navbar-custom-menu'>
              <ul className='nav navbar-nav'>
                <li
                  ref={(node) => {
                    this.node = node;
                  }}
                  onClick={this.handleClick}
                  className={
                    this.state.logoutButton == true
                      ? "dropdown user user-menu show"
                      : "dropdown user user-menu"
                  }
                >
                  <Link
                    href='#'
                    className='dropdown-toggle'
                    data-toggle='dropdown'
                  >
                    <img
                      src={imagePath}
                      className='user-image'
                      alt='User Image'
                      onError={(e) => {
                        e.target.src = defaultImagePath;
                      }}
                    />
                    <span className='hidden-xs name-capitalize'>
                      {user.firstName ? user.firstName : ""}{" "}
                      {user.lastName ? user.lastName : ""}
                    </span>{" "}
                  </Link>
                  <ul
                    className={
                      this.state.logoutButton === true
                        ? "dropdown-menu popupdropdown show"
                        : "dropdown-menu popupdropdown"
                    }
                  >
                    <li className='user-setting'>
                      {" "}
                      <Link
                        to={{ pathname: "/specialist/my-accounts", state: 1 }}
                      >
                        <img
                          src={require("../../../images/accountb.png")}
                          className='user-image'
                          alt='User Image'
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span>My Account</span>
                      </Link>
                    </li>
                    <li className='user-setting'>
                      {" "}
                      <Link
                        to={{ pathname: "/specialist/my-settings", state: 1 }}
                      >
                        <img
                          src={require("../../../images/Slicing/Settings-profile.png")}
                          className='user-image'
                          alt='User Image'
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span>Settings</span>
                      </Link>
                    </li>
                    <li
                      className='user-footer passwordLink'
                      // style={{ textAlign: "center" }}
                    >
                      <Link className='uploadLink' onClick={this._logout}>
                        <img
                          src={require("../../../images/Slicing/logout-profile.png")}
                          className='user-image'
                          alt='User Image'
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span> Sign out</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>
        <div className='content-wrapper'>
          <section className='content container-fluid'>
            <ToastContainer />
            {this.state.icloudEmailInput ? (
              <CalendarEmailInput
                icloudEmailModalOpen={this.state.icloudEmailInput}
                icloudEmailModalClose={() =>
                  this.setState({ icloudEmailInput: false })
                }
              />
            ) : (
              ""
            )}
            <div className='row'>
              <div className='section-accounts col-md-12'>
                <div className='boxMrgB'>
                  <div className='section-accounts__wrap'>
                    <div className='section-accounts__title'>
                      <h4 className='section-accounts__title-h4'>
                        My Accounts
                      </h4>
                    </div>
                    <div className='section-accounts__content'>
                      <div
                        className='card-item item'
                        onClick={() => this.handleOpenModal()}
                      >
                        <span className='card-item__span'>Subscription</span>
                        <div className='card-item__thumbnail'>
                          <img
                            className='img-fluid img-1'
                            src={require("../../../images/subscriptionb.png")}
                            alt=''
                          />
                        </div>
                      </div>
                      <Link
                        className='item'
                        to='/specialist/my-accounts/security'
                      >
                        <div className='card-item'>
                          <span className='card-item__span'>Security</span>
                          <div className='card-item__thumbnail'>
                            <img
                              className='img-fluid img-2'
                              src={require("../../../images/securityb.png")}
                              alt=''
                            />
                          </div>
                        </div>
                      </Link>
                      <Link
                        className='item'
                        to='/specialist/my-accounts/payment'
                      >
                        <div className='card-item'>
                          <span className='card-item__span'>Payment</span>
                          <div className='card-item__thumbnail'>
                            <img
                              className='img-fluid img-3'
                              src={require("../../../images/paymentb.png")}
                              alt=''
                            />
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Modal
            isOpen={this.state.showModal}
            onRequestClose={() => this.closeModal()}
            closeTimeoutMS={200}
            contentLabel='Example Modal'
            className='section-modal'
            overlayClassName='section-overlay'
          >
            <div className='section-modal__header'>
              <div className='section-modal__title'>
                <h1 className='section-modal__title-h1'>
                  {"{Selected Plan Name}"}
                </h1>
                <h2 className='section-modal__title-h2'>{"{Taka / Month}"}</h2>
              </div>
              <p className='section-modal__para'>
                Your subscription payment will be billed on August 1st, 2020.
                Cancel anytime
              </p>
            </div>
            <div className='section-modal__body'>
              <div className='section-modal__col'>
                <div className='section-modal__form-group form-group'>
                  <label for='card-name'>CardHolder Name</label>
                  <input
                    className='form-control'
                    id='card-name'
                    type='text'
                    placeholder='Cardholder Name'
                  />
                </div>
                <div className='section-modal__form-group form-two'>
                  <div className='form-group'>
                    <label for='card-expiration'>Card Expiration</label>
                    <DatePicker
                      id='card-expiration'
                      selected={this.state.startDate}
                      onChange={this.handleChange}
                      placeholderText='MM / YY'
                      className='form-control'
                    />
                  </div>
                  <div className='form-group'>
                    <label for='security-code'>Security code</label>
                    <input
                      id='security-code'
                      className='form-control'
                      type='text'
                      placeholder='CVC'
                    />
                  </div>
                </div>
              </div>
              <div className='section-modal__col'>
                <div className='section-modal__form-group form-group'>
                  <label for='card-number'>Card number</label>
                  <input
                    id='card-number'
                    className='form-control'
                    type='text'
                    placeholder='Card number'
                  />
                </div>
                <div className='section-modal__form-group'>
                  <div className='form-group'>
                    <label for='bill-zip'>Billing zip</label>
                    <input
                      id='bill-zip'
                      className='form-control'
                      type='text'
                      placeholder='Zipcode'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='section-modal__footer'>
              <div className='section-modal__term'>
                <span>
                  Learn about our fee structure{" "}
                  <Link to='/marketing/terms'>here</Link>
                </span>
              </div>
              <div className='section-modal__button'>
                <button className='section-modal__button-cancel'>Cancel</button>
                <button
                  className='section-modal__button-upgrade'
                  onClick={() => this.handleOpenModal2()}
                >
                  Upgrade Now
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            isOpen={this.state.showModal2}
            onRequestClose={() => this.closeModal2()}
            closeTimeoutMS={200}
            contentLabel='Example Modal'
            className='section-modal upgraded'
            overlayClassName='section-overlay'
          >
            <h3 className='section-modal__title-h3'>Account Upgraded</h3>
            <div className='section-modal__thumbnail'>
              <img
                className='img-fluid'
                src={require("../../../images/circhek.png")}
              />
            </div>
            <p className='section-modal__thank'>
              Thank you for providing the best healthcare using Medfix
            </p>
            <p className='section-modal__doc'>
              If this page does not automatically redirect to My Documents,
              click <Link to='/specialist/my-documents'>here</Link>
            </p>
          </Modal>
          <div className='Copyrightafterlogin'>
            <p>Medfix &copy; 2018. All rights reserved</p>
          </div>
        </div>
      </div>
    );
  }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
  return {
    address: state.specialist.specialistList.specialistRecord,
    striperes: state.specialist.stripeDetails,
    specialistListAssistant: state.specialist.specialistListAssistant,
    userData: state.adminUser.userData ? state.adminUser.userData : {},
    gapi: state.gapi,
  };
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...specialistActions, ...dashboardActions },
      dispatch
    ),
    changePassactions: bindActionCreators(userActions, dispatch),
    usersAction: bindActionCreators(usersAction, dispatch),
    gapiAction: bindActionCreators(gapiAction, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MySettings);
